<template>
  <b-row>
    <b-col sm="12">
      <my-card title="Daftar Mitra Pembayaran">
        <template slot="button">
          <button-link v-if="cP(44)" :to="{name:'commissions'}" feather-icon="UsersIcon" name="Komisi Mitra"></button-link>
          <button-add v-if="cP(41)" :to="{name: 'partners-add'}" variant="primary"></button-add>
        </template>
        <template slot="body">
          <data-tables ref="datatables" endpoint="v1/payment_partners" :fields="fields">
            <template v-slot:3="{item}">
              <b-badge variant="light-primary" v-if="item[3]==1">Ya</b-badge>
              <b-badge variant="light-warning" v-else>Tidak</b-badge>
            </template>
            <template v-slot:4="{item}">
              <div class="float-none">
                <!-- <button-link size="sm" :to="{name:'partners-show',params:{id: item[4]}}" feather-icon="FolderIcon"></button-link> -->
                <button-link v-if="cP(42)" size="sm" :to="{name:'partners-edit',params:{id: item[4]}}" feather-icon="EditIcon"></button-link>
                <button-delete v-if="cP(43)" @ondelete="deleteRow" :id="item[4]" :name="`${item[0]} (${item[1]})`"></button-delete>
              </div>
            </template>
          </data-tables>
        </template>
      </my-card>
    </b-col>
  </b-row>
</template>

<script>
import ButtonAdd from '@/my-components/ButtonAdd.vue'
import DataTables from '@/my-components/DataTables.vue'
import ButtonDelete from '@/my-components/ButtonDelete.vue'
import ButtonLink from '@/my-components/ButtonLink.vue'
import {BBadge} from 'bootstrap-vue'

export default {
  components:{
    ButtonAdd,
    DataTables,
    ButtonDelete,
    ButtonLink,
    BBadge
  },
  data() {
    return {
      fields: {
        0:{sortable: true, searchable: true, label:'Kode'},
        1:{sortable: true, searchable: true, label:'Nama'},
        2:{sortable: true, searchable: true, label:'Keterangan'},
        3:{sortable: true, searchable: true, label:'Aktif'},
        4:{sortable: false, searchable: false, label:''},
      }
    }
  },
  methods:{
    async deleteRow(payload){
      try {
        await this.$store.dispatch('partners/destroy',payload)
        this.$refs.datatables.refresh()
        this.toastSuccess("OK","Data Berhasil Dihapus!")
      } catch (error) {
        this.handleError(error)
      }
    }
  }
}
</script>

<style>

</style>